import styled from 'styled-components';
import { speed } from 'src/ui/common/config/animations';
import { Typography } from 'src/ui/common/atoms/typography';
import { FlexBox } from 'src/ui/common/atoms/flex-box';

const AVATAR_SIZE = 76;

export const StyledWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.gs500};
  border-radius: 5px;
  min-width: 200px;
`;

export const StyledInfo = styled.div`
  padding: 55px 20px 20px;
  text-align: center;
  position: relative;
`;

export const StyledCreatorName = styled.a`
  width: fit-content;
  margin: 0 auto 5px;
  color: ${({ theme }) => theme.colors.gs200};
`;

export const StyledName = styled(FlexBox)`
  color: ${({ theme }) => theme.colors.white};

  & > div {
    position: relative;
    padding-right: 23px;
    max-width: calc(100% - 23px);
  }

  & svg {
    position: absolute;
    right: 0;
    color: ${({ theme }) => theme.colors.blue500};
    margin-left: 5px;
  }
`;

export const StyledImgWrapper = styled.div`
  border-radius: 5px;
  overflow: hidden;
  
  & img {
    transition: transform ${speed.content} ease-in;
  }
  
  &:hover img {
    transform: scale(1.1, 1.1);
  }
`;

export const StyledImgPreviewWrapper = styled.div`
  position: absolute;
  top: -${AVATAR_SIZE / 2}px;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 50%;
  width: ${AVATAR_SIZE}px;
  overflow: hidden;
  
  & > div {
    border-radius: ${AVATAR_SIZE}px;
  }
`;

export const StyledDescription = styled(Typography)`
  color: ${({ theme }) => theme.colors.gs200};
  margin-top: 10px;
  height: 40px;
`;
export const StyledStatisticItem = styled.div`
  white-space: nowrap;
  flex: 1;
`;

export const StyledStatistics = styled(FlexBox)`
  margin-top: 16px;
  
  & > div {
    padding: 10px;
    background: ${({ theme }) => theme.colors.warmBlack};
    border-radius: 5px;
  }
  
  & > div + div {
    margin-left: 5px;
  }
  
  & > div:last-child {
    flex: 2;
  }
`;
